import styled from 'styled-components';

import { Spinner } from '@vimeo/bokeh';

const LoadingSpinner = styled(Spinner)`
  margin: 30vh auto 40vh;
  display: flex;
  justify-content: center;
`;

export default LoadingSpinner;
